import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const PeopleIcon: FunctionComponent = () => <MaterialUiIcons.People />;

export default PeopleIcon;
